/**
 * veldToegankelijkheid.js — gedeeld gedrag voor de veldcomponenten.
 *
 * Lost drie dingen op die in elk veldcomponent afzonderlijk mis waren:
 *
 * 1. `aria-describedby` wees naar een hardgecodeerd id="nameHelp" dat op elke
 *    pagina meerdere keren voorkwam, en nooit naar de foutmelding. Nu wordt de
 *    verwijzing samengesteld uit de uitleg én de fout, met unieke id's.
 * 2. Er was geen `aria-invalid`, dus een schermlezer kon niet weten dat een veld
 *    is afgekeurd.
 * 3. De foutmelding werd getoond met een inline display-stijl die alleen bij een
 *    validatiepoging werd herberekend. Corrigeerde de gebruiker het veld, dan
 *    bleef de melding staan. Nu volgt hij ook de invoer.
 *
 * De foutmelding wordt bewust met `display` verborgen en niet met opacity: alleen
 * display:none haalt de node uit de toegankelijkheidsboom, zodat een
 * aria-describedby-verwijzing ernaar genegeerd wordt zolang er geen fout is.
 */
export default {
  props: {
    // Id's komen van SFormElement, dat ze één keer afleidt uit element.name.
    ids: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      ongeldig: false,
      ooitGevalideerd: false,
    };
  },

  computed: {
    heeftUitleg() {
      const uitleg = this.element && this.element.explanation;
      return !!(uitleg && uitleg[this.lang]);
    },

    /** Uitleg en foutmelding samen, in de volgorde waarin ze voorgelezen horen. */
    describedBy() {
      const delen = [];
      if (this.heeftUitleg && this.ids.help) delen.push(this.ids.help);
      if (this.ongeldig && this.ids.error) delen.push(this.ids.error);
      return delen.length ? delen.join(' ') : undefined;
    },

    /** Nooit aria-invalid="false" wegschrijven; dat is enkel ruis. */
    ariaInvalid() {
      return this.ongeldig ? 'true' : undefined;
    },

    invalidStyle() {
      return this.ongeldig ? { display: 'block' } : {};
    },
  },

  watch: {
    wasValidated(waarde) {
      this.ooitGevalideerd = !!waarde;
      this.herbeoordeel();
    },
  },

  methods: {
    /**
     * Het bijbehorende formulierelement. De componenten gebruiken uiteenlopende
     * ref-namen (inputField_x, textarea_x, selectField), dus zoeken we de eerste
     * ref die zich als formulierelement gedraagt.
     */
    veldElement() {
      const refs = this.$refs || {};
      for (const sleutel of Object.keys(refs)) {
        const el = refs[sleutel];
        if (el && typeof el.checkValidity === 'function') return el;
      }
      return null;
    },

    herbeoordeel() {
      if (!this.ooitGevalideerd) {
        this.ongeldig = false;
        return;
      }
      const el = this.veldElement();
      this.ongeldig = el ? !el.checkValidity() : false;
    },
  },
};
